module.exports = __webpack_public_path__ + "img/careercolor.9bdf6a85.svg";